var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipDateTimePicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.52344C8.29333 7.52344 6.5 9.31677 6.5 11.5234C6.5 13.7301 8.29333 15.5234 10.5 15.5234C12.7067 15.5234 14.5 13.7301 14.5 11.5234C14.5 9.31677 12.7067 7.52344 10.5 7.52344ZM10.5 14.5234C8.84 14.5234 7.5 13.1834 7.5 11.5234C7.5 9.86344 8.84 8.52344 10.5 8.52344C12.16 8.52344 13.5 9.86344 13.5 11.5234C13.5 13.1834 12.16 14.5234 10.5 14.5234Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.52344H10V11.7301L11.2933 13.0234L12 12.3168L11 11.3168V9.52344Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.52344H11V3.52344H13V6.52344H14V3.52344C14 2.9701 13.5533 2.52344 13 2.52344H11V1.52344H10V2.52344H6V1.52344H5V2.52344H3C2.44667 2.52344 2 2.9701 2 3.52344V13.5234C2 14.0768 2.44667 14.5234 3 14.5234H5V13.5234H3V3.52344H5V4.52344H6V3.52344H10V4.52344Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipDateTimePicker);
export default __webpack_public_path__ + "static/media/ic-chip-date-time-picker.4cac635093a019ad4dbafd2bcf6856c4.svg";
export { ForwardRef as ReactComponent };